import React, { useCallback, useState } from 'react';
import * as clipboard from 'clipboard-polyfill';

import ClipboardCopyIcon from '../assets/svg/clipboard-copy.svg';
import CircleCheckIcon from '../assets/svg/circle-check.svg';

const CopyCode = ({ code }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = useCallback(async (ct) => {
    try {
      await clipboard.writeText(ct);

      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2500);
      // eslint-disable-next-line no-unused-vars
    } catch (e) {
      setCopied(false);
    }
  }, []);

  return (
    <div className="relative">
      <pre>{code}</pre>
      <button
        type="button"
        className="absolute top-2 right-2 p-1 bg-oxford-blue hover:bg-oxford-blue-400 rounded border"
        onClick={() => copyToClipboard(code)}
      >
        {copied ? (
          <CircleCheckIcon className="w-4 h-4 text-green-500" />
        ) : (
          <ClipboardCopyIcon className="w-4 h-4 text-white" />
        )}
      </button>
    </div>
  );
};

export default CopyCode;
